import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Planner from "@/pages/Planner";
import Settings from "@/pages/Settings";
import Clients from "@/pages/Clients";
import JobCards from "@/pages/JobCards";
import Workload from "@/pages/Workload";
import Timesheet from "@/pages/Timesheet";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center text-[#103080]/60" data-testid="app-loading">
    Loading…
  </div>
);

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return <AppShell>{children}</AppShell>;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return user ? <Navigate to="/" replace /> : <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/" element={<Protected><Planner /></Protected>} />
            <Route path="/clients" element={<Protected><Clients /></Protected>} />
            <Route path="/job-cards" element={<Protected><JobCards /></Protected>} />
            <Route path="/hours" element={<Navigate to="/settings/hours" replace />} />
            <Route path="/workload" element={<Protected><Workload /></Protected>} />
            <Route path="/timesheet" element={<Protected><Timesheet /></Protected>} />
            <Route path="/templates" element={<Navigate to="/settings/templates" replace />} />
            <Route path="/team" element={<Navigate to="/settings/team" replace />} />
            <Route path="/settings/*" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" toastOptions={{ className: "rounded-xl font-[Figtree]" }} />
      </AuthProvider>
    </div>
  );
}

export default App;
